 

<template>
<div> 

    <div class="calendar_box" >
        <el-calendar v-model="calendar_data"> 
            <template
                
                slot="dateCell"
                slot-scope="{date, data}">

                <div  @click="changeDate(date,data)"  :class="calendar_dic[data.day.split('-').join('')]? 'calendar_item_remind':''    "> 
                    {{data.day.split('-').slice(1)[1]}} 
                    <!-- {{ data.day.split('-').join('') }}  -->
                <!-- {{ data.day.split('-').slice(1).join('-') }}  -->
                <!-- {{ data.isSelected ? '✔️' : ''}} -->
    
                </div>
            </template>



        </el-calendar>

    </div>

    <div  class="cal_notice"  >{{calendar_msg}} </div>



   
    <div  v-for="(item,index) of itemList"  v-bind:key="index">
      <div class="item"   :data-id="item._id"  @click="check_detail(item)">
          <!-- bindtap="listItemClickEvent" -->
          <!--暂时取消了： bindlongtap="listItemLongTapEvent" -->
        <div class="inner ">
            <!-- {{isEditMode ? 'with-check' : ''}} -->
          <!-- <div class="checker" v-if="isEditMode"> 
            <icon type="circle" v-if="!item.checked" color="#FFF" size="20" />
            <icon type="success" wx:else color="#E14848" size="20" />
          </div>  -->

          <img v-if="item.sharefrom_avatar && item.sharefrom_avatar !='' && item.sharefrom_avatar !='null' " class="icon" :src='item.sharefrom_avatar' />
          <img v-if="item.level == 0 && !item.sharefrom_avatar" class="icon" src="https://11law.lawtip.cn/images/level_0.png" /> 
          <img v-if="item.level == 1 && !item.sharefrom_avatar" class="icon" src="https://11law.lawtip.cn/images/courtjudge.png" />
          <img v-if="item.level == 2 && !item.sharefrom_avatar" class="icon" src="https://11law.lawtip.cn/images/level_2.png" />
          <img v-if="item.level == 3 && !item.sharefrom_avatar" class="icon" src="https://11law.lawtip.cn/images/level_3.png" />
          <img v-if="item.level == 4 && !item.sharefrom_avatar" class="icon" src="https://11law.lawtip.cn/images/level_4.png" />
        
          <div class="content">
            <span class="title">{{item.title}}</span>
          </div>

          <div class="time">
             {{item.start_time}}
          </div>

        </div>
      </div>
    </div> 

    <div   class="float-action"  @click="newCalendar">
        <img src="@/assets/images/plus.png" />     

    </div> 

    <el-dialog
        title="日程详情"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <!-- <span>这是一段信息</span> -->
        <!-- <el-input v-model="lawtype" placeholder="请输入内容"></el-input> -->
            <el-form   :model="caldata">
                <el-form-item label="标题" label-width="80px">
                <!-- <el-input v-model="caldata.title" autocomplete="off"  ></el-input> -->
                    <div>{{caldata.title}}</div>
                </el-form-item>

                <el-form-item label="内容" label-width="80px">
                    <div>{{caldata.content}}</div>
                </el-form-item>

                <el-form-item label="事务安排" label-width="80px">
                    <div v-if="caldata.level == 0"  class="ball bg-level_0">   </div> 
                    <div v-if="caldata.level == 1"  class="ball bg-level_1">   </div> 
                    <div v-if="caldata.level == 2"  class="ball bg-level_2">  </div> 
                    <div v-if="caldata.level == 3"  class="ball bg-level_3">  </div> 
                    <div v-if="caldata.level == 4"  class="ball bg-level_4">  </div> 
                </el-form-item>



                <el-form-item label="事项日期" label-width="80px">
                    <div> {{caldata.year}}年{{caldata.month}}月{{caldata.date}}日  </div>
                </el-form-item>

                <el-form-item label="起止时间" label-width="80px">
                    <span v-if="caldata.start_time != '尚未设置' && caldata.start_time"> {{caldata.start_time}}开始 </span>
                    <span v-if="caldata.end_time != '尚未设置' && caldata.end_time"> ~{{caldata.end_time}}结束 </span>
                </el-form-item>

                <el-form-item label="添加日期" label-width="80px">
                    <div> {{caldata.addDate}}   </div>
                </el-form-item>

                <el-form-item label="来源" label-width="80px">
                    <div>  {{caldata.sharefrom?caldata.sharefrom:''}}   </div>
                </el-form-item>

                <el-form-item label="事项位置" label-width="80px">
                    <div v-if="caldata.location != '添加地点'&& caldata.location">  
                        
                        
                        <!-- {{caldata.location}}     -->


                        <a  target="_blank" :href=" 'http://api.map.baidu.com/geocoder?address='+caldata.location+'&output=html&src=webapp.baidu.openAPIdemo' ">
                            <font size="2.5" color="#1db5ee">{{caldata.location}}  </font>
                        </a>
 
                        
                        
                        
                    </div>
                    <!-- (点击导航） -->
                </el-form-item>

                <el-form-item label="附件照片" label-width="80px">
                    <div>   </div>
                </el-form-item>

                <img_list :imgList="caldata.accessory" > </img_list>  
                <!-- mark -->
                <!-- <el-form-item label="活动区域"  label-width="80px">
                <el-select v-model="caldata.region" placeholder="请选择活动区域">
                    <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option>
                </el-select>
                </el-form-item> -->
            </el-form>







        <span slot="footer" class="dialog-footer">
        
            <el-button v-if=" $store.state.userInfo.userId== caldata.userid || $store.state.userInfo.mini_openid==caldata.openid  "  type="info" plain style="margin-right:20px" @click="check_delete_cal">删 除</el-button>
            <el-button v-if=" $store.state.userInfo.userId== caldata.userid  || $store.state.userInfo.mini_openid==caldata.openid "  type="warning"  style="margin-right:20px" @click="edit_cal">编 辑</el-button>

       
       

            

            <el-button @click="dialogVisible = false">关 闭</el-button>
        </span>
    </el-dialog>




    <el-dialog
        :title="dialog_title[edit_mode]"
        :visible.sync="dialog_edit_vis"
        width="30%"
        :close-on-click-modal ="false"
        :before-close="handleClose2">
 
            <el-form   ref="form" :model="caldata">

                 
                <el-form-item label="日期" label-width="80px">
                    <!-- <el-input  :value="dateinfo.year+'-'+dateinfo.month+ '-' +dateinfo.date"   disabled placeholder='必填' ></el-input> -->
                    <div>{{ dateinfo.year+'-'+dateinfo.month+ '-' +dateinfo.date }}</div>
                </el-form-item>

                <el-form-item label="标题" label-width="80px">
                    <el-input v-model="caldata.title"  placeholder='必填' ></el-input>
                </el-form-item>

                <el-form-item label="内容" label-width="80px">
            
                    <el-input
                        type="textarea"
                        :rows="3"
                        :maxlength="200"
                        placeholder="请输入内容，不超过200个字符"
                        v-model="caldata.content">
                    </el-input>
                </el-form-item>

                <el-form-item label="事务安排" label-width="80px">
             
                    <el-select v-model="caldata.level" placeholder="无分类">

                        <el-option label="无分类"  value="0"> </el-option>
                        <el-option label="开庭"  value="1"> </el-option>
                        <el-option label="会议"  value="2"> </el-option>
                        <el-option label="会见客户"  value="3"> </el-option>
                        <el-option label="任务"  value="4"> </el-option>
                    </el-select>


                </el-form-item>



                <!-- <el-form-item label="事项日期" label-width="80px">
                    <div> {{caldata.year}}年{{caldata.month}}月{{caldata.date}}日  </div>
                </el-form-item> -->

 




                <el-form-item label="起止时间" label-width="80px">

                    <el-time-picker
                        style='width:30%'
                        format='HH:mm'
                        value-format="HH:mm"
                        v-model="caldata.start_time"
                   
                        placeholder="任意时间">
                    </el-time-picker>
                    <span style="width:50px;text-align:center"> 至 </span>
                    
                    <el-time-picker
                        format='HH:mm'
                        value-format="HH:mm"
                        style='width:30%'
                      
                        v-model="caldata.end_time"
                      
                        placeholder="非必填">
                    </el-time-picker>
   
                    <!-- <el-time-picker
                        format='HH:mm'
                        value-format="HH:mm"
                        is-range
                        @blur='change_time_range'
                        v-model="caldata.time_range"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间" 
                        placeholder="选择时间范围"> 
                    </el-time-picker> -->
                </el-form-item>

                <el-form-item label="上传附件" label-width="80px">
                    <div> 暂只支持使用小程序上传附件  </div> 
                </el-form-item>

                <!-- <el-form-item label="添加日期" label-width="80px">
                    <div> {{caldata.addDate}}   </div>
                </el-form-item>

                <el-form-item label="来源" label-width="80px">
                    <div>  {{caldata.sharefrom?caldata.sharefrom:''}}   </div>
                </el-form-item>

                <el-form-item label="事项位置" label-width="80px">
                    <div v-if="caldata.location != '添加地点'&& caldata.location">  
                        


                        <a  target="_blank" :href=" 'http://api.map.baidu.com/geocoder?address='+caldata.location+'&output=html&src=webapp.baidu.openAPIdemo' ">
                            <font size="2.5" color="#1db5ee">{{caldata.location}}  </font>
                        </a>
 
                        
                        
                         
                    </div>
           
                </el-form-item>

                <el-form-item label="附件照片" label-width="80px">
                    <div>   </div>
                </el-form-item>

                <img_list :imgList="caldata.accessory" > </img_list> -->
 
            </el-form>







        <span slot="footer" class="dialog-footer">
            <el-button type="primary"  @click="confirmNewCal(edit_mode)" >确 定</el-button>

            <el-button @click="handleClose2" style="margin-left:20px">关 闭</el-button>
           
            <!-- @click="modifyClassHandle" -->
        </span>
    </el-dialog>




</div>

</template>

 

<script>
    /**
     * 生成GUID序列号
     * @returns {string} GUID
     */
    function guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    import img_list from  '@/components/yu/imgList.vue';

    export default {
        name:'calendar_items',
        components: {
            img_list
                
        },
		props: {
         
        //  itemList:Array,
        //  dateinfo:Object,
        },
        data() {
			return {
                data: {},
                dialogVisible:false,
                dialog_edit_vis:false,
                caldata:{},
                draft:0,
                imgList_test:[],
                edit_mode:'new', //new,edit,
                dialog_title:{ 'new':'新建','edit':'编辑'},
                time_range: [new Date(), new Date()],
                newcal:{},

                calendar_data:new Date(),
                dateinfo:{},
                calendar_msg:'数据与律师云助理小程序同步',
                calendar_dic:{},
                itemList:[],
                
                
			};
        },
        created(){
            
            this.$nextTick(() => {
                // 点击前一个月
                let prevBtn = document.querySelector(
                    ".el-calendar__button-group .el-button-group>button:nth-child(1)"
                );
                prevBtn.addEventListener("click", e => {
              
                    // this.$notify({
                    //     title: "上一月",
                    //     message: "上个月头天：" + this.value,
                    //     type: "success",
                    //     position: "top-left",
                    //     duration:5000
                    // });


                    let dateinfo=this.dateinfo 

                    let y=dateinfo.after_year 
                    let m=dateinfo.before_month

                    let beforeYear, //上页月年份 
                    beforMonth, //上页月份
                    afterYear, //下页年份
                    afterMonth; //下页月份
            

                    //上一个月月份
                    beforMonth = m === 1 ? 12 : m - 1;
                    //上一个月年份
                    beforeYear = m === 1 ? y - 1 : y;
                    //下个月月份
                    afterMonth = m === 12 ? 1 : m + 1;
                    //下个月年份
                    afterYear = m === 12 ? y + 1 : y;

                    console.log('dateinfo:',dateinfo)

                    dateinfo={
                        after_month: afterMonth,
                        after_year: afterYear,
                        before_month: beforMonth,
                        before_year: beforeYear,
                        month: m,
                        year: y,
                        date:1
                    }
                    this.dateinfo=dateinfo


                    this.GetThisMonCal(dateinfo)




                });
            
                //点击下一个月
                let nextBtn = document.querySelector(
                    ".el-calendar__button-group .el-button-group>button:nth-child(3)"
                );
                nextBtn.addEventListener("click", () => {
                    console.log(this.value);
                    // this.$notify({
                    //     title: "下一月",
                    //     message: "下个月头天：" + this.value,
                    //     type: "warning",
                    //     position: "top-left"
                    // });


                    let dateinfo=this.dateinfo 
                    let y=dateinfo.after_year 
                    let m=dateinfo.after_month

                    let beforeYear, //上页月年份 
                    beforMonth, //上页月份
                    afterYear, //下页年份
                    afterMonth; //下页月份
            

                    //上一个月月份
                    beforMonth = m === 1 ? 12 : m - 1;
                    //上一个月年份
                    beforeYear = m === 1 ? y - 1 : y;
                    //下个月月份
                    afterMonth = m === 12 ? 1 : m + 1;
                    //下个月年份
                    afterYear = m === 12 ? y + 1 : y;

                    dateinfo={
                        after_month: afterMonth,
                        after_year: afterYear,
                        before_month: beforMonth,
                        before_year: beforeYear,
                        month: m,
                        year: y,
                        date:1
                    }
                    this.dateinfo=dateinfo


                    this.GetThisMonCal(dateinfo)





                });
            
                //点击今天
                let todayBtn = document.querySelector(
                    ".el-calendar__button-group .el-button-group>button:nth-child(2)"
                );
                todayBtn.addEventListener("click", () => {
                    // this.$notify.info({
                    // title: "今天",
                    // message: "今天：" + this.value,
                    // position: "top-left"
                    // });
                });

                this.setDateInfo(new Date())
                this.GetThisMonCal(this.dateinfo)




            });

        },
		methods: {
			// handleSizeChange(val) {
			// 	console.log('每页 ${val} 条');
			// },
			handleCurrentChange(val) {
				window.console.log('当前页:',val);
				this.$emit('ChangePage',val);  
            },
            check_detail(item){
                this.dialogVisible=true 
                
                this.caldata=item
                console.log("check_detail:",item)

                let arr=[];
                let pic_preurl = 'https://lawassist.oss-cn-hangzhou.aliyuncs.com/mix/';
                // let date = new Date();
                // let timesecond = date.getMilliseconds();
                for(let i=0;i<4;i++){
                    let t={
                        url_mini: pic_preurl + item._id + i + '.png-resize_pic' ,
                        url: pic_preurl + item._id + i + '.png'  
                    }
                    arr.push(t);
                    
                } 
                this.caldata.accessory=arr  //mark
                console.log('this.caldata.accessory:',this.caldata.accessory)
                // this.setData({
                //     accessory:arr
                // })



            },
            newCalendar(){
                this.dialog_edit_vis=true 
                this.edit_mode='new'
                // this.draft=1
                this.caldata={}
            },
            
            handleClose(){
                this.dialogVisible = false
            },
            handleClose2(){

             

                this.dialog_edit_vis=false

            },

            confirmNewCal(edit_mode){  
                console.log('edit_mode:',edit_mode)
                console.log("caldata:",this.caldata)
                let dd=this.caldata

                console.log('dateinfo:',this.dateinfo)
                if(!dd.title || dd.title.length<2){
                    this.$message({
                        message: '标题不可为空或者少于2个字符哦',
                        type: 'warning',
                        duration:4000
                    });
                    return
                }

                let date=new Date()
                let y=date.getFullYear();      // 获取当前年份
                let m=date.getMonth() + 1;    //返回的月份少一个月 需要+1
                let d=date.getDate(); 
                let addDate=y+'-'+m+'-'+d 
                let month_date=this.dateinfo.month+'-' + this.dateinfo.date

                // let caldata={
                   
                //     title: dd.title,
                //     content: dd.content || '' ,
                //     // _id: guid(),
                //     level: dd.level || '0' ,
                //     isnotice: "no",
                //     latitude: "",
                //     longitude: "",
                //     location: "添加地点",
                //     groupid_toshare: "none",
                //     // addDate: addDate,

                //     date: this.dateinfo.date,
                //     // end_time: month_date+' '+ this.caldata.time_range[0] ,
                //     month: this.dateinfo.month,
                //     // start_time:  month_date+' '+ this.caldata.time_range[1] ,
                //     year:  this.dateinfo.year,
                // }
                var caldata
                if(edit_mode=='edit'){
                    caldata=this.caldata

                }else if(edit_mode=='new'){
                    caldata={
                        title: dd.title,
                        content: dd.content || '' ,
                        _id: guid(),
                        level: dd.level || '0' ,
                        isnotice: "no",
                        latitude: "",
                        longitude: "",
                        location: "添加地点",
                        groupid_toshare: "none",
                        addDate: addDate,

                        date: this.dateinfo.date,
                        end_time:  dd.end_time || '尚未设置',   // month_date+' '+ this.caldata.time_range[0] ,
                        month: this.dateinfo.month,
                        start_time: dd.start_time || '尚未设置',   // month_date+' '+ this.caldata.time_range[1] ,
                        year:  this.dateinfo.year,
                    }
                }




                // if(this.caldata.time_range ){
                //     // console.log('1111111111111111111')
                //     if(this.caldata.time_range[0]){
                //         caldata.start_time= month_date+' '+ this.caldata.time_range[0]
                //     }else{
                //         caldata.start_time= '尚未设置' 
                //     }

                //     if(this.caldata.time_range[1] && this.caldata.time_range[0]!='尚未设置'){
                //          caldata.end_time=month_date+' '+ this.caldata.time_range[1]
                //     }else{
                //         caldata.end_time= '尚未设置' 
                //     }

                     
                    

                // }else{
               

                //     caldata.start_time='尚未设置'
                //     caldata.end_time='尚未设置'
                // }

                console.log("caldata2:",caldata)
                this.caldata=caldata
                this.save(edit_mode)
                
            },

            save(mode){

                var that=this
                var data={
                    // whattodo: 'saveNewCal',
                    caldata: this.caldata
                }

                if(mode=='new'){
                    data.whattodo='saveNewCal'
                }else if(mode=='edit'){
                    data.whattodo='replaceCal'
                }

                this.axios.post(this.$root.rootUrl+'calendar2'   ,data
                ).then(function (res) {
                    window.console.log(res)
                    
                    if(res.status==200 ){
                        window.console.log(res.data.data);
                        var result=res.data
                        if(result.status=='badgate'){
                            that.$message({
                                message: '请先登录哦',
                                type: 'warning',
                                duration:4000
                            });
                         
                        }else  if(result.status=='ok'){
                            that.$message({
                                message: '保存成功',
                                type: 'success',
                                duration:4000
                            });
                             
                            let prefix=''+that.caldata.year+ (String(that.caldata.month).length==1? '0'+that.caldata.month :that.caldata.month )  + (String(that.caldata.date).length==1? '0'+that.caldata.date :that.caldata.date )
                            
                            
                            if(mode=='new'){ //edit部分的逻辑没有
                                if(!that.calendar_dic[prefix]){
                                    that.calendar_dic[prefix]= [that.caldata]
                                }else{
                                    that.calendar_dic[prefix].push(that.caldata)
                                }
                                that.caldata={}

                            } 
                        
                          
                            console.log('prefix:',prefix)
                            // Vue.set(that.calendar_dic, prefix , that.caldata)

                            // that.caldata={}
                            that.dialog_edit_vis=false 
                            that.draft=0



                            // for(let p of data){
                            //     let prefix=p.year+ (p.month.length==1? '0'+p.month :p.month )  + (p.date.length==1? '0'+p.date :p.date )
                            //     // console.log('prefix:',prefix)
                            //     if(!res_dic[prefix]){
                            //         res_dic[prefix]=[p]
                            //     }else{
                            //         res_dic[prefix].push(p)
                            //     }

                            // }
                            // console.log("res_dic:",res_dic)
                            // that.calendar_dic=res_dic

                         

                            

                        }else  if(result.status=='fail'){
                            that.$message({
                                message: result.failMsg  || '未知原因失败，请联系客服'  ,
                                type: 'error',
                                duration:4000
                            });
                            that.dialog_edit_vis=false 
                         

                            

                        }
                    

                    }
                    
                    
                }).catch(function (error) {
                    window.console.log(error);
                    
                });








            },

            check_delete_cal(){
                var that=this
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.delete_cal()
              
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });


            },
            edit_cal(){  
                // if(this.draft){
                //     this.caldata=this.draft 
                // }
                let c= this.caldata
                var that=this 
                this.edit_mode='edit'
                // this.caldata.time_range=['','']

                let a1,a2,time_range1,time_range2

                if(!this.caldata.start_time || this.caldata.start_time=='尚未设置'){
                    this.caldata.start_time=''
                }
                if(!this.caldata.end_time || this.caldata.end_time=='尚未设置'){
                    this.caldata.end_time=''
                }
               
                // if(this.caldata.start_time && this.caldata.start_time!='尚未设置'){
                //     // this.caldata.time_range[0]=this.caldata.start_time.slice(-5);
                //     a1=this.caldata.start_time.slice(-5)
                   
                //     // console.log('a1.slice(0,2)',a1.slice(0,2))
                //     // console.log('a1.slice(2,4)',a1.slice(2,4))
                //     time_range1=new Date(c.year, c.month, c.date, a1.slice(0,2) , a1.slice(3,5))
                //     console.log('time_range1:',time_range1)
                //     // this.caldata.time_range=[time_range1,time_range1]
                //     this.$set(this.caldata,  'time_range' ,[time_range1,time_range1]  )

                //     // this.caldata.time_range[0]=new Date(c.year, c.month, c.date, a1.slice(0,2) , a1.slice(3,5))

                //     // 
                //     // this.$set(this.caldata.time_range, 0, new Date(c.year, c.month, c.date, a1.slice(0,2) , a1.slice(3,5)) )
                // }
                
                // if(this.caldata.end_time && this.caldata.end_time!='尚未设置'){
                //     // this.caldata.time_range[1]=this.caldata.end_time.slice(-5);
                //     a2=this.caldata.end_time.slice(-5)
                //     // this.caldata.time_range[1]=new Date(c.year, c.month, c.date, a2.slice(0,2) , a2.slice(3,5))
                //     // this.$set(this.caldata.time_range, 1, new Date(c.year, c.month, c.date, a1.slice(0,2) , a1.slice(3,5)) )
                // }

                
                // let c=this.caldata.time_range

                // this.$set(this.caldata, 'time_range', [a1,a2]  )
                // this.caldata.time_range

               

                console.log('this.caldata.time_range:',this.caldata.time_range)
                this.dialogVisible=false 
                this.dialog_edit_vis=true 


            },

            delete_cal(){
                var that=this
                var data={
                    whattodo: 'delete_cal',
                    _id: this.caldata._id
                }
                this.axios.post(this.$root.rootUrl+'calendar2'   ,data
                ).then(function (res) {
                    window.console.log(res)
                    
                    if(res.status==200 ){
                        window.console.log(res.data.data);
                        var result=res.data
                        if(result.status=='badgate'){
                            that.$message({
                                message: '请先登录哦',
                                type: 'warning',
                                duration:4000
                            });
                         
                        }else  if(result.status=='ok'){
                            that.$message({
                                message: '删除成功',
                                type: 'success',
                                duration:4000
                            });

                            let prefix=''+that.caldata.year+ (String(that.caldata.month).length==1? '0'+that.caldata.month :that.caldata.month )  + (String(that.caldata.date).length==1? '0'+that.caldata.date :that.caldata.date )
                            if(that.calendar_dic[prefix].length==1){
                                delete that.calendar_dic[prefix];
                                that.calendar_dic=that.calendar_dic
                              
                            }else if(that.calendar_dic[prefix].length>1){
                                let len=that.calendar_dic[prefix].length 
                                let n=0
                                for( n;n<len-1;n++   ){
                                    if(that.calendar_dic[prefix][n]._id==that.caldata._id){
                                        break
                                    }

                                }
                                that.calendar_dic[prefix] = that.calendar_dic[prefix].splice(n, 1)
                                
                            }


                   
                            that.dialogVisible=false
                            
                            
               

                         

                            

                        }else  if(result.status=='fail'){
                            that.$message({
                                message: result.failMsg  || '未知原因失败，请联系客服'  ,
                                type: 'error',
                                duration:4000
                            });
                            that.dialog_edit_vis=false 
                         

                            

                        }
                    

                    }
                    
                    
                }).catch(function (error) {
                    window.console.log(error);
                    
                });
            },

            setDateInfo(date){
                let y=date.getFullYear();      // 获取当前年份
                let m=date.getMonth() + 1;    //返回的月份少一个月 需要+1
                let d=date.getDate();  

                let beforeDayCount = 0,
                beforeYear, //上页月年份 
                beforMonth, //上页月份
                afterYear, //下页年份
                afterMonth; //下页月份


                //上一个月月份
                beforMonth = m === 1 ? 12 : m - 1;
                //上一个月年份
                beforeYear = m === 1 ? y - 1 : y;
                //下个月月份
                afterMonth = m === 12 ? 1 : m + 1;
                //下个月年份
                afterYear = m === 12 ? y + 1 : y;



                let dateinfo={
                    after_month: afterMonth,
                    after_year: afterYear,
                    before_month: beforMonth,
                    before_year: beforeYear,
                    month: m,
                    year: y,
                    date:d
                }

                this.dateinfo=dateinfo
                
            },
            change_time_range(v){
                console.log('v:',v)
                // this.caldata.time_range=this.caldata.time_range

                // this.$set(this.caldata, 'time_range',  this.caldata.time_range )
                if(this.caldata.time_range[0]){
                    this.caldata.time_range[0]=this.caldata.time_range[0]
                }
                if(this.caldata.time_range[1]){
                    this.caldata.time_range[1]=this.caldata.time_range[1]
                }
                this.caldata=this.caldata

                console.log(' this.caldata.time_range :', this.caldata.time_range )

                // this.$set(this.caldata, 'time_range',   [  this.caldata.time_range[0],this.caldata.time_range[1]           ] )

                // Vue.set(this.caldata, 'time_range',   [  this.caldata.time_range[0],this.caldata.time_range[1]           ] )
            },


            changeDate(date,data){
                console.log('date:',date , 'data:',data) 

                let date_last=this.calendar_data
                let last_y=date_last.getFullYear();      // 获取当前年份
                let last_m=date_last.getMonth() + 1;    //返回的月份少一个月 需要+1
                let last_d=date_last.getDate();  



                // console.log('date:',date)
                // console.log( date.year,date.month,date.day)

                let y=date.getFullYear();      // 获取当前年份
                let m=date.getMonth() + 1;    //返回的月份少一个月 需要+1
                let d=date.getDate();            // 几号

                // console.log(y)
                // console.log(m)
                // console.log(d)

                // console.log('------------------')
                // console.log(last_y)
                // console.log(last_m)
                // console.log(last_d)
                


                
                let beforeDayCount = 0,
                beforeYear, //上页月年份 
                beforMonth, //上页月份
                afterYear, //下页年份
                afterMonth; //下页月份
        

                //上一个月月份
                beforMonth = m === 1 ? 12 : m - 1;
                //上一个月年份
                beforeYear = m === 1 ? y - 1 : y;
                //下个月月份
                afterMonth = m === 12 ? 1 : m + 1;
                //下个月年份
                afterYear = m === 12 ? y + 1 : y;
  


                let dateinfo={
                    after_month: afterMonth,
                    after_year: afterYear,
                    before_month: beforMonth,
                    before_year: beforeYear,
                    month: m,
                    year: y,
                    date:d
                }


                // if(y!=this.dateinfo.year || m!=this.dateinfo.month){
                //     console.log('change month')
                //     this.GetThisMonCal(dateinfo)
                // }

                this.dateinfo=dateinfo
                console.log('this.calendar_dic:',this.calendar_dic)

                if(this.calendar_dic[data.day.split('-').join('')] ){
                    this.itemList=this.calendar_dic[data.day.split('-').join('')] 
                }else{
                    this.itemList=[]
                }
 
                // console.log("this.calendar_dic:",this.calendar_dic)
                


            },
            GetThisMonCal(dateInfo){
                // let beforeDayCount = 0,
                // beforeYear, //上页月年份 
                // beforMonth, //上页月份
                // afterYear, //下页年份
                // afterMonth; //下页月份
        

                // //上一个月月份
                // beforMonth = m === 1 ? 12 : m - 1;
                // //上一个月年份
                // beforeYear = m === 1 ? y - 1 : y;
                // //下个月月份
                // afterMonth = m === 12 ? 1 : m + 1;
                // //下个月年份
                // afterYear = m === 12 ? y + 1 : y;
  


                // let dateinfo={
                //     after_month: afterMonth,
                //     after_year: afterYear,
                //     before_month: beforMonth,
                //     before_year: beforeYear,
                //     month: m,
                //     year: y,
                // }


                // console.log('dateInfo:',dateInfo)
                var that=this
                var data={
                    whattodo: 'GetThisMonCal',
                    dateInfo: dateInfo
                }
                this.axios.post(this.$root.rootUrl+'calendar2'   ,data
                    ).then(function (res) {
                        // window.console.log(res)
                        
                        if(res.status==200 ){
                            // window.console.log(res.data.data);
                            var result=res.data
                            if(result.status=='badgate'){
                                // that.$message({
                                //     message: '请先登录哦',
                                //     type: 'warning',
                                //     duration:4000
                                // });
                                that.calendar_msg='登录后可以同步日历数据'
                                // that.$message('请先登录哦');
                            }else  if(result.status=='ok'){
                                let data=result.data 
                                let res_dic={}
                                for(let p of data){
                                    let prefix=p.year+ (p.month.length==1? '0'+p.month :p.month )  + (p.date.length==1? '0'+p.date :p.date )
                                    // console.log('prefix:',prefix)
                                    if(!res_dic[prefix]){
                                        res_dic[prefix]=[p]
                                    }else{
                                        res_dic[prefix].push(p)
                                    }

                                }
                                // console.log("res_dic:",res_dic)
                                that.calendar_dic=res_dic

                                

                            }
                        

                        }
                       
                        
                    }).catch(function (error) {
                        window.console.log(error);
                        
                    });

            },
          




		},
 
	}



</script>

<style   > 
    /* 日历部分 */
    
    .el-calendar-day {
        /* width: 55px!important; */
        height: auto!important;
        /* padding: 4px!important; */
   
        text-align: center!important; 
    }


    .calendar_item_remind{
        /* background-color: #DCDFE6; */
        background: #d3dce6;
        border-radius: 4px;
    }

    .el-calendar__title{
        font-size:14px;
    }
    .cal_notice{
        /* padding-left:25px; */
        width: 100%;
        font-size:14px;
        margin-bottom:20px;
        /* border:1px solid rgb(65, 56, 56);  */

        text-align: center;
        color: #272829;
        margin-top:-10px;

    }
    
    .float-action {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        /* box-shadow: 2px 2px 10px rgba(0, 0, 0, .5);  */
        background: #E14848; 
        z-index: 100;
        text-align: center;
        opacity: .5;
        margin-left: 40px;
        /* margin-bottom: 100rpx; */
        float: right;
    }
    .float-action:active {
        opacity: 1
    }
    .float-action img {
        width: 25px;
        height: 25px;
        /* margin: auto ; */
        margin-top: 7px;
    }
    .is-selected{
        /* background-color: #F2F8FE;   */
        background-color: #bad2eb!important;
    }
</style>

<style scoped>


/* .common-list{
  margin-top:15px;

} */

.item {
    overflow: hidden;
    /* border : 1px solid #333; */

    width: 95%;
    /* background-color: white; */
    margin: 0 auto 15px auto;
    border-radius: 15px ;

    height:60px;

    display: flex;
    flex-direction: row;
    align-items: center;
    /* background-color: #f6f8fa; */
    background-color: #e0ebf7;
    cursor: pointer;
}
.item:active {
    background: #333333
}
.item .inner {
    position: relative;
    /* border : 1px solid rgb(226, 23, 23); */
    margin: 0 4px;
    /* padding: 10px 0; */
    /* min-height: 100px; */

    width:98%;

    display: flex;
    flex-direction: row;
    align-items: center;

}

.header {
    /* border-top: 2px solid #333; */
    margin: 0 40px;  
    padding: 20px 0;
    color: #AAA;
    font-size: 30px;
}

.item .icon {
    /* position: absolute; */
    left: 0;
    /* top: 20px; */
    width: 40px;
    height: 40px;
    border-radius: 50%;

    /* border : 1px solid rgb(226, 23, 23); */
}
.item .inner.with-check .checker {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 0;
    top: 10px;
    bottom: 10px;
    width: 80px;
    /* border-right: 2px solid #333; */
}
/* .item .inner.with-check .icon {
    left: 100px;
} */
.item .content {
    margin-left: 15px;
    /* border: 1px solid rgb(223, 31, 31); */
    /* margin: auto 0 auto 130px; */
    height: 100%;

    width:63%;

}
.item .time {
    margin-left: 10px;
    /* border: 1px solid rgb(223, 31, 31); */
    /* margin: auto 0 auto 130px; */
    height: 100%;

    width:14%;
    font-size:14px;

}


/* .item .inner.with-check .content{
    margin-left: 230px;
} */
.item .title {
    display: block;
    overflow: hidden;
    white-space:nowrap;
    text-overflow: ellipsis;
    /* font-weight: lighter; */
    font-size: 16px;
    /* margin-top: 30px; */

    /* border: 1px solid rgb(26, 168, 126); */

}

.el-form-item{
    margin-bottom: 10px;
}

.bg-level_0 {  /* 默认 */
  /* background: #46BC62 !important; */

  background-size: contain;
  background-position: center center;
  background-image: url("https://11law.lawtip.cn/images/level_0.png");
  background-repeat: no-repeat;
}


.bg-level_1 {   /*  开庭*/
   /* background: #ECAA5B !important;  */
  background-size: contain;
  background-position: center center;
  background-image: url("https://11law.lawtip.cn/images/courtjudge.png");
  background-repeat: no-repeat;
}
.bg-level_2 {    /* */
/*  background: #E14848 !important; */
    background-size: contain;
  background-position: center center;
  background-image: url("https://11law.lawtip.cn/images/level_2.png");
  background-repeat: no-repeat;
}
.bg-level_3 {    /*  */
/*  background: #E14848 !important; */
    background-size: contain;
  background-position: center center;
  background-image: url("https://11law.lawtip.cn/images/level_3.png");
  background-repeat: no-repeat;
}
.bg-level_4 {    /*  合同*/
/*  background: #E14848 !important; */
    background-size: contain;
  background-position: center center;
  background-image: url("https://11law.lawtip.cn/images/level_4.png");
  background-repeat: no-repeat;
}
.ball {
    width: 40px;
    height: 40px;
    border-radius: 50%;
}



  .float-action {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        /* box-shadow: 2px 2px 10px rgba(0, 0, 0, .5);  */
        background: #E14848; 
        z-index: 100;
        text-align: center;
        opacity: .5;
        margin-left: 40px;
        /* margin-bottom: 100rpx; */
        float: right;
        cursor: pointer;
    }
    .float-action:active {
        opacity: 1
    }
    .float-action img {
        width: 25px;
        height: 25px;
        /* margin: auto ; */
        margin-top: 7px;
    }


</style>
